import React from 'react';
import styled from 'styled-components';
import styles from '../../../styles';
import { Icon } from '../../../icons';
import { Button } from './';

const jsonp = (url, successCallback, errorCallback) => {
  const callbackName = 'jsonp_callback_' + Math.round(100000 * Math.random());
  window[callbackName] = data => {
    delete window[callbackName];
    document.body.removeChild(script);
    successCallback(data);
  };

  const script = document.createElement('script');
  script.onerror = data => {
    delete window[callbackName];
    document.body.removeChild(script);
    errorCallback(data);
  };
  script.src = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'c=' + callbackName;
  document.body.appendChild(script);
};

const Form = styled.form`
  margin-bottom: 4rem;

  div.fieldContainer {
    display: flex;
    flex-direction: column-reverse;
    border-bottom: 1px solid ${styles.color.ORANGE};
    line-height: 1.75rem;
    margin-bottom: 2rem;
    padding-top: 2rem;
    ${props =>
      props.breakpoint !== 'phone' &&
      `
    max-width: 75%;
    position: relative;
    `} &.checkbox {
      max-width: unset;
      border: 0;
      flex-direction: row;
    }
  }
	
  div.fieldTitle {
    line-height: 1.75rem;
    margin-bottom: 1.5rem;
    padding-top: 2rem;
    color: ${styles.color.ORANGE};
		font-size: 1.4375rem;
  }
  div.legaltext {
    line-height: 1.75rem;
    padding-top: 2.5rem;
  }

  label,
  input,
  select {
    margin: 0;
    padding: 0;
    outline: 0;
    font-family: inherit;
    background-color: transparent;
    border: 0;
    appearance: unset;
    line-height: inherit;
  }

  label,
  input {
    font-size: 1.4375rem;
  }

  select.hasValue {
    font-size: 1.4375rem;
  }

  label:not(.checkbox) {
    color: ${styles.color.ORANGE};
    position: absolute;
    pointer-events: none;
  }

  label.select {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
		
    svg {
      width: 1rem;
      height: 1rem;
    }
  }
	
  label.checkbox {
    color: ${styles.color.ORANGE};
  }

  label.checkbox {
    display: flex;
    align-items: center;
  }

  input[type='checkbox'] {
    border: 1px solid ${styles.color.ORANGE};
    width: 1.5rem;
    height: 1.5rem;
    margin-right: 1rem;
    position: relative;
    flex-shrink: 0;
    ${props =>
      props.breakpoint === 'phone' &&
      `
      align-self: flex-start;
    `} &:after {
      content: '\\2713 ';
      color: inherit;
      width: 1.5rem;
      height: 1.5rem;
      text-align: center;
      line-height: inherit;
      font-family: inherit;
      display: none;
    }

    &:checked {
      &:after {
        display: block;
      }
    }
  }

  input:focus + label,
  input.hasValue + label,
  select:focus + label,
  select.hasValue + label {
    font-size: 1rem;
    margin-top: -1.35rem;
  }

  div.error {
    bottom: -1.75rem;
    position: absolute;
    color: #f00;
  }
`;

const MailchimpResult = styled.p`
  font-family: ApercuBold;
`;

class EmailSignupForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      formData: {
        FNAME: '',
        LNAME: '',
        EMAIL: '',
				GAMER: '',
				MMERGE8: '',
				GAMEDEV: '',
				GAMEDESIGN: '',
				ART: '',
				ANALYTICS: '',
				LIVEOPS: '',
				COMMUNITY: '',
				CSR: '',
				RELEASES: '',
				JOBS: '',
        gdpr_36079: '',
        b_e6713f5cd275e23b8cd9821e6_ce8edb7fa1: '',
      },
      mailChimpMessage: '',
      showErrors: false,
      isSubmitting: false,
      submitCompleted: false,
      errors: [],
      formError: '',
      touchedFields: [],
      isValid: false,
    };
  }

  onInputChange = event => {
    const { target: { name, value, type, checked } } = event;
    const { formData } = this.state;
    value !== ''
      ? event.target.classList.add('hasValue')
      : event.target.classList.remove('hasValue');
    this.setState(
      {
        formData: {
          ...formData,
          [name]: type !== 'checkbox' ? value : checked,
        },
      },
      () => {
        this.validate();
      }
    );
  };

  isValidEmail = email => {
    const regex = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    return regex.test(email);
  };

  isValidString = str => {
    return str.length > 0;
  };

  isValidCheckboxValue = val => {
    return val;
  };

  validate = () => {
    const { formData: { FNAME, LNAME, EMAIL, GAMER, MMERGE8, gdpr_36079 } } = this.state;

    const errors = [];
    if (!this.isValidEmail(EMAIL)) {
      errors.push('EMAIL');
    }
    if (!this.isValidString(FNAME)) {
      errors.push('FNAME');
    }
    if (!this.isValidString(LNAME)) {
      errors.push('LNAME');
    }
    if (!this.isValidString(GAMER)) {
      errors.push('GAMER');
    }
		if (!this.isValidString(MMERGE8)) {
      errors.push('MMERGE8');
    }
    if (!this.isValidCheckboxValue(gdpr_36079)) {
      errors.push('gdpr_36079');
    }
    const isValid = errors.length === 0;
    this.setState({
      errors,
      isValid,
    });
  };

  updateTouchedfields(event) {
    const { name } = event.target;
    if (name === '') return;
    const touchedFields = [
      ...this.state.touchedFields.filter(item => item !== name),
      name,
    ];
    this.setState({
      touchedFields,
    });
  }

  onBlur = event => {
    this.updateTouchedfields(event);
    this.validate();
  };

  submitForm = event => {
    this.validate();
    this.setState({
      showErrors: true,
    });

    const { isValid } = this.state;
    if (!isValid) return;

    this.setState({
      isSubmitting: true,
      formError: '',
      submitCompleted: false,
      submitFailed: false,
    });

    this.doSubmit();
  };

  doSubmit = () => {
    const {
      formData: {
        FNAME,
        LNAME,
        EMAIL,
				GAMER,
        MMERGE8,
				GAMEDEV,
				GAMEDESIGN,
				ART,
				ANALYTICS,
				LIVEOPS,
				COMMUNITY,
				CSR,
				RELEASES,
				JOBS,
        gdpr_36079,
        b_e6713f5cd275e23b8cd9821e6_ce8edb7fa1,
      },
    } = this.state;
    const formData = new FormData();
    formData.set('FNAME', FNAME);
    formData.set('LNAME', LNAME);
    formData.set('EMAIL', EMAIL);
		formData.set('GAMER', GAMER);
    formData.set('ROLE', MMERGE8);
		formData.set('GAMEDEV', GAMEDEV == true ? 'Yes' : 'No');
		formData.set('GAMEDESIGN', GAMEDESIGN == true ? 'Yes' : 'No');
		formData.set('ART', ART == true ? 'Yes' : 'No');
		formData.set('ANALYTICS', ANALYTICS == true ? 'Yes' : 'No');
		formData.set('LIVEOPS', LIVEOPS == true ? 'Yes' : 'No');
		formData.set('COMMUNITY', COMMUNITY == true ? 'Yes' : 'No');
    formData.set('CSR', CSR == true ? 'Yes' : 'No');
		formData.set('RELEASES', RELEASES == true ? 'Yes' : 'No');
		formData.set('JOBS', JOBS == true ? 'Yes' : 'No');
    formData.set('gdpr[36079]', gdpr_36079 == true ? 'Y' : false);
    formData.set('b_e6713f5cd275e23b8cd9821e6_ce8edb7fa1', b_e6713f5cd275e23b8cd9821e6_ce8edb7fa1);
    const params = Array.from(formData, e =>
      e.map(encodeURIComponent).join('=')
    ).join('&');

    const url = `https://spaceapegames.us4.list-manage.com/subscribe/post-json?u=e6713f5cd275e23b8cd9821e6&amp;id=ce8edb7fa1&${params}`;
    jsonp(
      url,
      response => {
        const { result, msg } = response;
        this.setState({
          mailChimpMessage: msg,
          submitCompleted: result === 'success',
          isSubmitting: false,
        });
      },
      error => {
        console.log(error);
        this.setState({
          mailChimpMessage: 'Error submitting form.',
          submitCompleted: false,
          isSubmitting: false,
        });
      }
    );
  };

  render() {
    const {
      formData: {
        FNAME,
        LNAME,
        EMAIL,
				GAMER,
        MMERGE8,
				GAMEDEV,
				GAMEDESIGN,
				ANALYTICS,
				ART,
				LIVEOPS,
				COMMUNITY,
				CSR,
				RELEASES,
				JOBS,
        gdpr_36079,
        b_e6713f5cd275e23b8cd9821e6_ce8edb7fa1,
      },
      errors,
      touchedFields,
      showErrors,
      isSubmitting,
      submitCompleted,
      mailChimpMessage,
    } = this.state;

    return (
      <React.Fragment>
        {!submitCompleted && (
          <React.Fragment>
            <Form
              breakpoint={this.props.breakpoint}
              noValidate
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
            >
              <div className="fieldContainer">
                {errors.indexOf('FNAME') > -1 &&
                  (touchedFields.indexOf('FNAME') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
                <input
                  id="mce-FNAME"
                  name="FNAME"
                  type="text"
                  value={FNAME}
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                />
                <label htmlFor="mce-FNAME">
                  First name <span className="asterisk">*</span>
                </label>
              </div>
              <div className="fieldContainer">
                {errors.indexOf('LNAME') > -1 &&
                  (touchedFields.indexOf('LNAME') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
                <input
                  id="mce-LNAME"
                  name="LNAME"
                  type="text"
                  value={LNAME}
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                />
                <label htmlFor="mce-LNAME">
                  Last name <span className="asterisk">*</span>
                </label>
              </div>

              <div className="fieldContainer">
                {errors.indexOf('EMAIL') > -1 &&
                  (touchedFields.indexOf('EMAIL') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
                <input
                  id="mce-EMAIL"
                  name="EMAIL"
                  type="email"
                  value={EMAIL}
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                />
                <label htmlFor="mce-EMAIL">
                  Email address <span className="asterisk">*</span>
                </label>
              </div>
							
							
              <div className="fieldContainer">
                {errors.indexOf('GAMER') > -1 &&
                  (touchedFields.indexOf('GAMER') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
                <select
                  id="mce-GAMER"
                  name="GAMER"
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                  value={GAMER}
                >
                  <option value="" />
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                  <option value="Wish">I would like to</option>
                </select>
                <label htmlFor="mce-GAMER" className="select">
                  Do you work in games? * <Icon icon="#arrow-down" />
                </label>
              </div>
							
              <div className="fieldContainer">
                {errors.indexOf('MMERGE8') > -1 &&
                  (touchedFields.indexOf('MMERGE8') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
                <select
                  id="mce-MMERGE8"
                  name="MMERGE8"
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                  value={MMERGE8}
                >
                  <option value="" />
									<option value="Analytics">Analytics</option>
                  <option value="Art / UI / UX">Art / UI / UX</option>
									<option value="Audio">Audio</option>
									<option value="Business Development">Business Development</option>
									<option value="Cinematics / Video">Cinematics / Video</option>
									<option value="Client Development">Client Development</option>
									<option value="Customer Support / Community">Customer Support / Community</option>
									<option value="DevOps / IT">DevOps / IT</option>
									<option value="Finance / Operations">Finance / Operations</option>
                  <option value="Game Design">Game Design</option>
                  <option value="Live Ops">Live Ops</option>
									<option value="QA">QA</option>
									<option value="Recruitment">Recruitment</option>
                  <option value="Server Development">Server Development</option>
                  <option value="Student">Student</option>
									<option value="UA / Marketing">UA / Marketing</option>
									<option value="Other">Other</option>
                </select>
                <label htmlFor="mce-MMERGE8" className="select">
                  What best describes your role? * <Icon icon="#arrow-down" />
                </label>
              </div>
									
							<div className="fieldTitle">	
                  What are you interested in?
							</div>
									
            <div className="fieldContainer checkbox">
              <label className="checkbox" htmlFor="interest_GAMDEV">
									<input id="interest_GAMEDEV" name="GAMEDEV" type="checkbox" value={GAMEDEV} onChange={this.onInputChange} onBlur={this.onBlur}/>Game Development
              </label>
            </div>
									
            <div className="fieldContainer checkbox">
              <label className="checkbox" htmlFor="interest_GAMEDESIGN">
								<input id="interest_GAMEDESIGN" name="GAMEDESIGN" type="checkbox" value={GAMEDESIGN} onChange={this.onInputChange} onBlur={this.onBlur}/>Game Design
              </label>
            </div>
						
            <div className="fieldContainer checkbox">
              <label className="checkbox" htmlFor="interest_ART">
									<input id="interest_ART" name="ART" type="checkbox" value={ART} onChange={this.onInputChange} onBlur={this.onBlur}/>Art
              </label>
            </div>
						
            <div className="fieldContainer checkbox">
              <label className="checkbox" htmlFor="interest_ANALYTICS">
								<input id="interest_ANALYTICS" name="ANALYTICS" type="checkbox" value={ANALYTICS} onChange={this.onInputChange} onBlur={this.onBlur}/>Analytics
              </label>
            </div>

									
            <div className="fieldContainer checkbox">
              <label className="checkbox" htmlFor="interest_LIVEOPS">
								<input id="interest_LIVEOPS" name="CSR" type="checkbox" value={LIVEOPS} onChange={this.onInputChange} onBlur={this.onBlur}/>Live Ops
              </label>
            </div>
						
            <div className="fieldContainer checkbox">
              <label className="checkbox" htmlFor="interest_COMMUNITY">
								<input id="interest_COMMUNITY" name="COMMUNITY" type="checkbox" value={COMMUNITY} onChange={this.onInputChange} onBlur={this.onBlur}/>Community Management
              </label>
            </div>
									
            <div className="fieldContainer checkbox">
              <label className="checkbox" htmlFor="interest_CSR">
									<input id="interest_CSR" name="CSR" type="checkbox" value={CSR} onChange={this.onInputChange} onBlur={this.onBlur}/>CSR (Corporate Social Responsibility) &amp; Green Initiatives
              </label>
            </div>
									
            <div className="fieldContainer checkbox">
              <label className="checkbox" htmlFor="interest_RELEASES">
								<input id="interest_RELEASES" name="RELEASES" type="checkbox" value={RELEASES} onChange={this.onInputChange} onBlur={this.onBlur}/>Game Releases
              </label>
            </div>
									
            <div className="fieldContainer checkbox">
              <label className="checkbox" htmlFor="interest_JOBS">
								<input id="interest_JOBS" name="JOBS" type="checkbox" value={JOBS} onChange={this.onInputChange} onBlur={this.onBlur}/>Job Opportunities
              </label>
            </div>
									
		            <div className="legaltext">
									<p>Your data will be held in line with our <a href="https://spaceapegames.com/privacy-policy">privacy policy</a>. You can unsubscribe at any time by clicking the link in the footer of our emails.</p>
						      <p>We use Mailchimp to send emails on our behalf. By subscribing, you acknowledge that your information will be transferred to Mailchimp for processing. Learn more about Mailchimp&apos;s <a href="https://mailchimp.com/legal/" rel="noopener noreferrer" target="_blank">privacy practices</a>.</p>
		            </div>
									
              <div className="fieldContainer checkbox">
                <label className="checkbox" htmlFor="gdpr_36079">
                  <input
                    id="gdpr_36079"
                    name="gdpr_36079"
                    type="checkbox"
                    value="Y"
                    onChange={this.onInputChange}
                    onBlur={this.onBlur}
                  />I confirm I wish to receive emails from Space Ape
                </label>
                {errors.indexOf('gdpr_36079') > -1 &&
                  (touchedFields.indexOf('gdpr_36079') > -1 || showErrors) && (
                    <div className="error">This field is required.</div>
                  )}
              </div>
									
							<div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true">
                <input
                  tabIndex="-1"
                  name="b_e6713f5cd275e23b8cd9821e6_ce8edb7fa1"
                  type="text"
                  onChange={this.onInputChange}
                  onBlur={this.onBlur}
                  value={b_e6713f5cd275e23b8cd9821e6_ce8edb7fa1}
                />
              </div>
            </Form>
                  
            
                  
            {!isSubmitting && (
              <Button onClick={this.submitForm}>Subscribe</Button>
            )}
						
          </React.Fragment>
        )}
        {mailChimpMessage && (
          <MailchimpResult
            dangerouslySetInnerHTML={{ __html: mailChimpMessage }}
          />
        )}
      </React.Fragment>
    );
  }
}

export default EmailSignupForm;



// WEBPACK FOOTER //
// ./src/modules/pages/components/EmailSignupForm.js